import { motion } from "framer-motion";

const COLUMNS = { 1: "lg:grid-cols-1", 2: "lg:grid-cols-2", 3: "lg:grid-cols-3", 4: "lg:grid-cols-4" };

export function SponsorLogos({ sponsors = [] }) {
  if (!sponsors.length) return null;
  return (
    <section className="relative z-10 border-y border-white/10 bg-charcoal" data-testid="sponsor-logos-strip">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-8 sm:px-8 lg:flex-row lg:items-center lg:gap-12">
        <p className="shrink-0 font-mono text-[10px] uppercase tracking-[0.32em] text-slate-500">Con el apoyo de</p>
        <div className={`grid flex-1 gap-4 sm:grid-cols-2 ${COLUMNS[Math.min(sponsors.length, 4)]}`}>
          {sponsors.map((sponsor, index) => {
            const content = (
              <>
                <img src={sponsor.logo_url} alt={`Logotipo de ${sponsor.name}`} loading="lazy" className="max-h-16 w-auto max-w-[200px] object-contain opacity-90 transition-opacity duration-500 group-hover:opacity-100" />
                <span className="sr-only">{sponsor.name}</span>
                {sponsor.tagline ? <span className="mt-2 block font-mono text-[9px] uppercase tracking-[0.2em] text-slate-500 group-hover:text-clay">{sponsor.tagline}</span> : null}
              </>
            );
            const classes = "group flex flex-col items-center justify-center border border-white/10 bg-white/[0.03] px-6 py-5 text-center transition-colors hover:border-clay/50";
            return (
              <motion.div key={sponsor.id} initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.08 }}>
                {sponsor.url ? <a href={sponsor.url} target="_blank" rel="noreferrer sponsored" className={classes} data-testid={`sponsor-logo-${sponsor.id}`}>{content}</a> : <div className={classes} data-testid={`sponsor-logo-${sponsor.id}`}>{content}</div>}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
